import { render, staticRenderFns } from "./ChatAreaPseudo.vue?vue&type=template&id=7e94caa0&scoped=true&"
var script = {}
import style0 from "./ChatAreaPseudo.vue?vue&type=style&index=0&id=7e94caa0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e94caa0",
  null
  
)

export default component.exports